import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form'

export const WealthContactCreateFields: React.FC = () => {
  const form = useFormContext()

  return (
    <Row className='mt-1 mb-4'>
      <Col>
        <Controller
          name='metadata.sendInvite'
          control={form.control}
          render={({ field }) => (
            <Form.Check
              id='metadata.sendInvite'
              type='checkbox'
              label='Send Wealth.com Client Portal invitation'
              checked={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </Col>
    </Row>
  )
}
